import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { FreeSpinReelControllerEvent, GameEvent } from "../../../controller/event/GameEvent";
import { FeatureTransitionEvents } from "../../../controller/FeatureTransitionController";
export class FreeSpinsRainbowOverlay extends AbstractGameView {
    constructor(factory, properties, portraitProperties) {
        super(factory, properties, portraitProperties);
        Logger.addObjectRef(this);
        this.overlay = TitanSpine.createSpine(this, this.landscapeProperties.overlayProperties, this.portraitProperties?.overlayProperties);
        this.overlay.visible = false;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_START, this.handleFreeSpinReelsStart);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_START, this.handleFreeSpinReelsEnd);
        this.registerGame(FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_START, this.handleFreeSpinReelsEnd);
        this.registerGame(GameEvent.FREE_SPIN_REELS_RECOVER, this.handleFreeSpinRecover);
        this.registerGame(FeatureTransitionEvents.TRANSITION_FEATURE_SELECTOR, this.handleFreeSpinReelsEnd);
        this.registerGame(CommonGameEvent.GAME_OVER_CONFIRMED, this.handleFreeSpinReelsEnd);
        this.registerGame(CommonGameEvent.REPLAY_FINISHED, this.handleFreeSpinReelsEnd);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.clearFreeSpinGraphics);
    }
    clearFreeSpinGraphics() {
        SpineUtil.stop(this.overlay);
        this.overlay.visible = false;
    }
    handleFreeSpinReelsStart() {
        this.overlay.visible = true;
        SpineUtil.play(this.overlay, ["freeSpinsReelIntro", "freeSpinsReelIntro_P"], () => {
            SpineUtil.playLoop(this.overlay, ["freeSpinsReelIdle", "freeSpinsReelIdle_P"]);
        });
        this.overlay.getSpine().update(0.001);
    }
    handleFreeSpinReelsEnd() {
        if (this.overlay.visible) {
            SpineUtil.play(this.overlay, ["freeSpinsReelOutro", "freeSpinsReelOutro_P"], () => {
                this.overlay.visible = false;
            });
        }
    }
    handleFreeSpinRecover() {
        this.handleFreeSpinReelsStart();
    }
}
//# sourceMappingURL=FreeSpinsRainbowOverlay.js.map